import React, {useState} from 'react';
import PageForm from "components/pageForm";
import SubNavbar from "components/SubNavbar/SubNavbar";
import SearchBar from "components/search/SearchBar";
import {TabF, TabsF} from "components/tabs/tabfile";
import {Outlet} from "react-router-dom";

const Mission = () => {
    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState('all');

    const missionSearchTypes = [
        { value: 'all', label: 'Tout', placeholder: 'Rechercher...' },
        { value: 'motif', label: 'Motif', placeholder: 'Sélectionner un motif' },
        { value: 'interimaire', label: 'Intérimaire', placeholder: 'Rechercher un intérimaire...' },
        { value: 'mission', label: 'Missions', placeholder: 'Rechercher une mission...' },
        { value: 'periode', label: 'Période', placeholder: 'Rechercher par période...' }
    ];

    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="w-full flex items-stretch h-full">
                        <div className="w-full flex flex-col tab:flex-row tab:justify-between gap-3">
                            <div className="flex items-center h-full">
                                <TabsF>
                                    <TabF label={"end"} tabName={'Terminées'}/>
                                    <TabF label={"inProgress"} tabName={'En cours'}/>
                                    <TabF label={"comingSoon"} tabName={'À venir'}/>
                                </TabsF>
                            </div>
                            <div className="flex flex-col tab:flex-row items-stretch tab:items-center gap-3 flex-shrink-0 tab:ml-4">
                                <SearchBar
                                    searchValue={searchValue}
                                    onSearchChange={setSearchValue}
                                    searchType={searchType}
                                    onSearchTypeChange={setSearchType}
                                    customSearchTypes={missionSearchTypes}
                                />
                            </div>
                        </div>
                    </div>
                </SubNavbar>
                <div className="col-span-12">
                    <Outlet context={{ searchValue, searchType }} />
                </div>
            </PageForm>
        </>
    );
};

export default Mission;